import { fileListItem } from './file_list_item';

$(() => {
  const key1 = 'show-file-info';
  const key2 = 'file-info-container';
  const key3 = 'rm-item';

  $('[data-template-id][data-write-to]').on('click', function() {
    const templateUrl = `/templates/${$(this).data('template-id')}/json`;
    const writeTo = $($(this).data('write-to'));
    const attachTo = $($(this).data('attach-to'));
    let template_file_ids = [];

    $.get(templateUrl, function(data) {
      writeTo.val(data.body);

      template_file_ids = data.attachments.map(a => a.id);
      attachTo.closest('form').append($(`<input hidden name="template_file_ids" value="${JSON.stringify(template_file_ids)}" id="template_file_ids" />`));

      $(attachTo.data(key1)).empty();
      $.each(data.attachments, function (index, val) {
        $(attachTo.data(key1)).append(
          fileListItem(val.original_filename, val.size, `data-${key3}='${val.id}'`)
        );
      });
      $(attachTo.data(key2)).removeClass('d-none');

      $(document).on('click', `[data-${key3}]`, function () {
        $(this).closest('li').remove();
        template_file_ids.splice(template_file_ids.indexOf($(this).data(key3)), 1);
        $('#template_file_ids').val(JSON.stringify(template_file_ids));
      });
    });
  });
});
